<ngx-spinner type="ball-clip-rotate"></ngx-spinner>

<ng-container *ngIf="initialized">
  <div *ngIf="page === 'login'">
    <app-doctors-next-login></app-doctors-next-login>
  </div>
  <div *ngIf="page === 'register'">
    <app-doctors-next-register></app-doctors-next-register>
  </div>

  <div *ngIf="page === 'forgot-password' || page === 'password-reset-send'">
    <app-doctors-next-forgot-password></app-doctors-next-forgot-password>
  </div>
  <div *ngIf="page === 'register-resend'">
    <app-doctors-next-register-resend></app-doctors-next-register-resend>
  </div>
  <!-- 送信しましたページ -->
</ng-container>
